import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ContentPasteOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"content_paste_off"}/>
}
